import React from "react";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    icon: {
        width: 34,
        marginRight: 5,
        marginTop: 8
    }
});

export default function Affiliate() {
    const classes = useStyles();
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z"></path>
            </svg>
}
